// extracted by mini-css-extract-plugin
export default {"auth-indicator":"distributeSim_auth-indicator__Dn7Hh"};